<template>
  <div>
    <Head :title="$t('actions.associate_model', [$t('labels.new_model', [$t('models.user')])])"/>

    <div class="flex justify-start mb-8">
      <h1 class="text-3xl font-bold">
        <Link class="text-indigo-400 hover:text-indigo-600" :href="route('admin.members.index')">
          {{ $t('models.member') }}
        </Link>
        <span class="text-indigo-400 font-medium mx-2">/</span>
        {{ $t('actions.associate_model', [$t('labels.new_model', [$t('models.user')])]) }}:
        {{ member.display_name }}
      </h1>
      <div class="ml-auto">
        <Link class="inline-block btn-indigo" :href="route('admin.members.edit', member.uuid)">
          <span>{{ $t('ui.back') }}</span>
        </Link>
      </div>
    </div>

    <div class="bg-white rounded-md shadow overflow-hidden">
      <form @submit.prevent="store">
        <div class="flex flex-wrap -mb-8 -mr-6 p-8">
          <text-input v-model="form.name" :error="form.errors.name"
                      class="pb-8 pr-6 w-full" :label="$t('fields.user.name')" readonly/>
          <text-input v-model="form.mobile" :error="form.errors.mobile"
                      class="pb-8 pr-6 w-full lg:w-1/2" :label="$t('fields.user.mobile')" readonly/>
          <text-input v-model="form.email" :error="form.errors.email"
                      class="pb-8 pr-6 w-full lg:w-1/2" :label="$t('fields.user.email')" readonly/>
          <text-input v-model="form.password" :error="form.errors.password"
                      class="pb-8 pr-6 w-full lg:w-1/2" type="password"
                      autocomplete="new-password" :label="$t('fields.user.password')" autofocus/>
          <text-input v-model="form.password_confirmation"
                      :error="form.errors.password_confirmation"
                      class="pb-8 pr-6 w-full lg:w-1/2" type="password"
                      autocomplete="new-password" :label="$t('fields.user.password_confirmation')"/>
          <select-input v-model="form.role" :error="form.errors.role"
                        class="pb-8 pr-6 w-full lg:w-1/2" :label="$t('fields.user.role')">
            <option v-for="role in roles" :value="role.id">{{ role.name }}</option>
          </select-input>
        </div>

        <div class="flex items-center justify-end px-8 py-4 bg-gray-50 border-t border-gray-100">
          <loading-button :loading="form.processing" class="btn-indigo" type="submit">
            {{ $t('actions.save') }}
          </loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Layout from '@/Layouts/Authenticated'
import FileInput from '@/Inputs/FileInput'
import TextInput from '@/Inputs/TextInput'
import SelectInput from '@/Inputs/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import TextareaInput from "@/Inputs/TextareaInput";

export default {
  components: {
    TextareaInput,
    FileInput,
    Head,
    Link,
    LoadingButton,
    SelectInput,
    TextInput,
  },
  props: {
    member: Object,
    roles: Object,
  },
  layout: Layout,
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        name: this.member.full_name.length ? this.member.full_name : this.member.slug,
        mobile: this.member.mobile,
        email: this.member.email,
        password: this.$page.props.default_user_password,
        password_confirmation: this.$page.props.default_user_password,
        role: this.roles.find(r => r.name === 'Member')?.id,
      }),
    }
  },
  methods: {
    store() {
      this.form.post(route('admin.members.create-user.store', this.member.uuid))
    },
  },
}
</script>
